import { Component, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material/icon';

import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';

import { MainSidenavComponent } from '@app/shared/components';

import { environment } from 'environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {

  static LANGUAGE_KEY = 'user-language';

  @ViewChild(MainSidenavComponent, {static: false}) sidenav: MainSidenavComponent;

  constructor(private store: Store<any>,
              private router: Router,
              private translateService: TranslateService,
              private matIconRegistry: MatIconRegistry,
              private domSanitizer: DomSanitizer) {
    this.initTranslate();
    this.initIconRegistry();
  }

  private initTranslate(): void {
    this.translateService.addLangs(['ro']);
    this.translateService.setDefaultLang(environment.defaultLanguage);
    this.translateService.use(this.currentLanguage);
  }


  private initIconRegistry() {
    this.matIconRegistry.addSvgIcon(
      'back_button_icon',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/images/icons/back_button_icon.svg')
    );
  }

  get currentLanguage(): string {
    const storedLang = localStorage.getItem(AppComponent.LANGUAGE_KEY);
    const defaultLang = environment.defaultLanguage;
    return storedLang || defaultLang;
  }
}
